<template>
  <div id="app" v-if="mounted">
    <navigation v-if="!isLoginRoute" :organisation="organisation"></navigation>
    <toaster-messages />
    <router-view />
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import ToasterMessages from "@/components/toaster/ToasterMessages";

export default {
  name: "App",
  components: {
    Navigation,
    ToasterMessages
  },
  data() {
    return {
      mounted: false,
      organisation: true
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    },
    isLoginRoute() {
      return this.$route.name === "login"
    }

  },
  mounted() {
    //TODO: Make check if meta data is available
    if(this.currentUser) {
      this.$store.dispatch("getStatus");
      this.$store.dispatch("getPaymentConditions");
      if (this.currentUser.organisation) {
        let organisation = this.currentUser.organisation;
        this.$store.dispatch("getOrganisationTemplates", organisation);
        this.$store.dispatch("getMeta", organisation).then(meta => {
          if (meta) {
            this.setThemeColors(meta)
          }
          this.mounted = true
        });
        this.$store.dispatch("getInvoices", organisation);
        this.$store.dispatch("getClients", organisation);
        if (this.currentUser.admin) {
          this.$store.dispatch('getOrganisations')
        }
      } else {
        this.mounted = true
        this.organisation = false
      }
    } else {
      this.organisation = false
      this.mounted = true
    }
  },
  methods: {
    setThemeColors(meta) {
      if (meta.theming && meta.theming.colorTheme.hex && meta.theming.colorTheme.rgba){
        document.querySelector(':root').style.setProperty('--color-theme', meta.theming.colorTheme.hex);
        document.querySelector(':root').style.setProperty('--color-invoice-theme', meta.theming.colorInvoiceTheme.hex);
        document.querySelector(':root').style.setProperty('--color-invoice-theme-values', `${meta.theming.colorInvoiceTheme.rgba.r}, ${meta.theming.colorInvoiceTheme.rgba.g}, ${meta.theming.colorInvoiceTheme.rgba.b}`);
        document.querySelector(':root').style.setProperty('--color-theme-values', `${meta.theming.colorTheme.rgba.r}, ${meta.theming.colorTheme.rgba.g}, ${meta.theming.colorTheme.rgba.b}`);
      }
    }
  }
};
</script>

<style lang="scss">
@import "./styles/colors";
@import "./styles/input-autocomplete";
@import "./styles/input-v-select";

body {
  padding: 0;
  margin: 0;
}

#app {
  font-family: Lato, sans-serif;
  color: #333333;
  height: 100vh;
}


.options {
  display: flex;
  button {
    border: none;
    height: 40px;
    font-size: 20px;
    cursor: pointer;
    margin-right: 10px;
    padding: 8px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-theme);

    i {
      margin-right: 4px;
      font-size: 18px;
    }

    span {
      font-size: 12px;
      font-weight: 600;
    }

    &:disabled {
      color: grey;
      cursor: default;
    }

    &:hover:not(:disabled) {
      background: rgba(var(--color-theme-values), 0.2);
    }
  }

  .delete {
    margin-right: 0;
    color: $color-danger;
    &:hover:not(:disabled) {
      background: rgba($color-danger, 0.1);
    }
  }

}

.main-actions {
  width: 50px;
  text-align: center;
  padding: 10px;
  background: var(--color-theme);
  margin: 0 auto 20px;
  border-radius: 0 0 4px 4px;
}

button {
  &.floater {
    border-radius: 50%;
    height: 30px;
    width: 30px;
    border: none;
    outline: none;
    color: var(--color-theme);
    background: white;
    cursor: pointer;
    box-shadow: 1px 1px 4px rgba(0,0,0,0.3);
    i {
      padding-top: 3px;
      font-size: 16px;
    }
    &:hover {
      background: darken(white, 2);
    }
    &:active {
      box-shadow: -1px -1px 4px rgba(0, 0, 0, 0.3);
    }
  }
}

.a4 {
  width: 21cm;
  height: 29.65cm;
  box-sizing: border-box;
}

@media print {
  body {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
}
</style>
